module.exports = __webpack_public_path__ + "static/media/me.9dc5e308.svg";